import React, {Component, createRef, Fragment} from 'react';
import autobind from 'autobind-decorator';

import {ObjectUtils} from "../../../Utils";

import {FileEditOverlay} from './FileEditOverlay';

import {service as FileUploadService} from "../../../Services/FileUploadService";
import {PermissionCheckerEnhance} from "../Enhancements/PermissionCheckerEnhance";

// TODO: rewrite as a hook?
export const FileEditorEnhance = ((ComposedComponent) =>
    @PermissionCheckerEnhance
    class FileEditorEnhance extends Component {
        constructor(props) {
            super(props);

            this.composedComponent = createRef();

            this.state = {
                displayEdit: false,
                validation: [],
                file: null,
                editedFile: null
            };
        }

        componentDidUpdate(prevProps, prevState, snapshot) {
            if (prevState.file !== this.state.file) {
                this.setState({editedFile: this.state.file});
            }
        }

        @autobind
        displayDialog(file) {
            this.setState({
                file: file,
                editedFile: ObjectUtils.Clone(file),
                displayEdit: true
            });
        }

        @autobind
        hideDialog() {
            this.setState({
                displayEdit: false
            });
        }

        @autobind
        saveFile() {
            const { editedFile } = this.state;

            FileUploadService.UpdateFile(editedFile)
                .then(() => {
                    this.hideDialog();

                    // If we're composing a component with a reload call back. Lets trigger it..
                    // Warning: because of the way we are using this composedComponent ref
                    // FileEditorEnhance must be the last included decorator to ensure this
                    // ref doesn't point to another HOC.
                    this.composedComponent?.current?.reloadData?.();
                })
                .catch((error) => {
                    alert(error?.message ?? "Unknown Error");
                });
        }

        @autobind
        deleteFile() {
            const { editedFile } = this.state;

            FileUploadService.DeleteFile(editedFile.fileUploadId)
                .then(() => {
                    this.hideDialog();

                    //If we're composing a component with a reload call back. Lets trigger it..
                    this.composedComponent?.current?.reloadData?.();
                });
        }

        @autobind
        update(file) {
            if(!ObjectUtils.Compare(this.state.editedFile, file)) {
                this.setState({editedFile: file});
            }
        }

        @autobind
        updateValidation(validation, editorGuid) {
            this.setState({
                validation: ObjectUtils.Clone(validation)
            });
        }


        render() {
            const { displayEdit, editedFile, validation } = this.state;
            const { EditableChecker, HasPermission } = this.props;
            const hasPermission = HasPermission('delete_file');
            let canEdit = false;

            if (editedFile) {
                canEdit = EditableChecker?.CanEditFileUpload(editedFile);
            }

            return <Fragment>
                {/* TODO: refactor this?*/}
                <FileEditOverlay
                    Display={displayEdit}
                    OnClose={this.hideDialog}
                    OnSave={this.saveFile}
                    OnDelete={hasPermission ? this.deleteFile : null}
                    CanDelete={canEdit && hasPermission}
                    File={editedFile}
                    OnUpdate={this.update}
                    OnValidationUpdate={this.updateValidation}
                    Validation={validation}
                />
                <ComposedComponent
                    ref={this.composedComponent}

                    FileEdit={{
                        DisplayEditOverlay: this.displayDialog,
                        HideEditOverlay: this.hideDialog
                    }}
                    {...this.props}
                />
            </Fragment>;
        }
    }
);

